// Helpers dùng chung cho module Warranty Service / Phiếu sửa chữa (FE).
// Tránh duplicate giữa RepairSlipForm / ListRepairSlips / MasterRepairInfos / MasterRepairErrorCodes.

import moment from 'moment';

/**
 * Trích message lỗi từ axios error → string user-facing.
 * @param {*} err
 * @returns {string}
 */
export const extractError = (err) => (
    err?.response?.data?.message
    || err?.message
    || 'Có lỗi xảy ra, vui lòng thử lại'
);

/**
 * Format số tiền VND theo locale vi-VN.
 * @param {number|string|null|undefined} value
 * @returns {string}
 */
export const formatPrice = (value) => {
    if (value === undefined || value === null) return '0';
    return Number(value).toLocaleString('vi-VN');
};

/**
 * Convert input từ date-picker (DD/MM/YYYY hoặc ISO) sang ISO YYYY-MM-DD cho BE.
 * @param {string|Date|null|undefined} input
 * @returns {string|null}
 */
export const toIsoDate = (input) => {
    if (!input) return null;
    if (input instanceof Date) {
        return moment(input).format('YYYY-MM-DD');
    }
    const m = moment(input, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
    return m.isValid() ? m.format('YYYY-MM-DD') : null;
};

/**
 * Convert ISO YYYY-MM-DD từ BE → DD/MM/YYYY cho date-picker hiển thị.
 * @param {string|Date|null|undefined} input
 * @returns {string}
 */
export const fromIsoDate = (input) => {
    if (!input) return '';
    const m = moment(input);
    return m.isValid() ? m.format('DD/MM/YYYY') : '';
};

/**
 * Format datetime ISO → DD/MM/YYYY HH:mm[:ss].
 * @param {string|Date|null|undefined} value
 * @param {boolean} [withSeconds=false]
 * @returns {string}
 */
export const formatDateTime = (value, withSeconds = false) => {
    if (!value) return '';
    return moment(value).format(withSeconds ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY HH:mm');
};
